import {SET_MESSAGE, CLEAR_MESSAGE} from "./types";
import RestService from "../services/rest.service";
// export const setMessage = (message) => ({
//   type: SET_MESSAGE,
//   payload: message,
// });
//
// export const clearMessage = () => ({
//   type: CLEAR_MESSAGE,
// });
//
// export const clearMessage = () => ({
//   type: CLEAR_MESSAGE,
// });
export const fetchCarryScore = () => (dispatch) => {
    const mockData = require("../../src/data/db.json")
    const oData = mockData.Planning_CarryScore;
    // mapping data
    dispatch({
        type: "SET_CARRY_SCORE",
        payload: oData,
    });
    return Promise.resolve();
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
export const updateCarryScore = (data) => (dispatch) => {
    return dispatch({
        type: "SET_CARRY_SCORE",
        payload: data,
    })
};
export const saveCarryScore = (data) => (dispatch) => {
    return RestService.post('Planning_CarryScore').then(
        (response) => {
            // mapping data
            dispatch({
                type: "SET_CARRY_SCORE",
                payload: response.data,
            });
            return Promise.resolve(response.data);
        },
        (error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            dispatch({
                type: "REGISTER_FAIL",
            });
            dispatch({
                type: "SET_MESSAGE",
                payload: message,
            });
            return Promise.reject();
        }
    );
};